import React, {Component} from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import {Link} from 'react-router-dom';
import {EditorDialog} from '../editor-components';
import EmailBoothReviewButton from './email-booth-review-button';

/** @class BoothButton
  * A component that provides a button that,
  * when clicked, displays a modal list of
  * booths associated with an exhibitor.
  * @param {object} booths - the booths to display,
  * as a map of expoID -> showID -> boothID -> booth name
  */
export default class BoothsButton extends Component {
  /** @constructor
    * Constructs a new intance of BoothsButton.
    */
  constructor(props) {
    super(props);
    this.state = {showDialog: false}
  }
  /** @render
    * Renders the component
    */
  render() {
    // Don't show a button if there are no booths
    if(!this.props.booths) return '';
    // Reorganize the tree structure of booths into an array
    var data = Object.keys(this.props.booths).map((key) => ({
      name: this.props.booths[key].name,
      expoID: this.props.booths[key].expo,
      showID: this.props.booths[key].show,
      boothID: key,
      status: this.props.booths[key].status,
      editURL: `/expos/${this.props.booths[key].expo}/shows/${this.props.booths[key].show}/booths/${key}`,
      reviewURL: `/expos/${this.props.booths[key].expo}/shows/${this.props.booths[key].show}/booths/${key}/review`
    }));
    var columns = [
      {Header: 'Booth', accessor: 'name'},
      {Header: 'Expo', accessor: 'expoID'},
      {Header: 'Show', accessor: 'showID'},
      {Header: 'Status', accessor: 'status'},
      {Header: 'Actions', filterable:false, accessor: 'boothID', Cell: (row) => {
        return (
          <span>
            <Link to={row.original.reviewURL}>
              <FontAwesome name="eye" style={{color: "green"}}/>
            </Link>
            <Link to={row.original.editURL}>
              <FontAwesome name="edit" style={{color: "orange"}}/>
            </Link>
            <EmailBoothReviewButton name={row.original.name}
                exhibitor={this.props.exhibitor}
                expoID={row.original.expoID}
                showID={row.original.showID}
                reviewURL={row.original.reviewURL} />
          </span>
        );
      }}
    ];
    return (
      <div>
        <EditorDialog show={this.state.showDialog} onExit={() => this.setState({showDialog: false})}>
          <ReactTable filterable data={data} columns={columns} style={{minWidth: "500px"}}/>
        </EditorDialog>
        <button className="btn btn-info" onClick={()=>this.setState({showDialog: true})}>
          <FontAwesome name="bookmark"/> Booth List
        </button>
      </div>
    )
  }
}

BoothsButton.propTypes = {
  booths: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/exhibitor-list/booths-button.js